import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftMappersFactory} from '../Mappers/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

export class UpdateAdPublisherUseCase extends UseCase {
  #fromDraftParamToRequestDraftValueObjectMapper
  #getCurrentUserService
  #httpRepository
  #userNotLoggedInUserError

  constructor({config}) {
    super()

    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    this.#fromDraftParamToRequestDraftValueObjectMapper =
      DraftMappersFactory.fromDraftParamToRequestDraftValueObjectMapper({
        config
      })
    this.#httpRepository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new UpdateAdPublisherUseCase({config})
  }

  @tracer({metric: 'UpdateAdPublisherUseCase#execute'})
  @inlineError
  async execute({adId, categoryId, fields, images}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: `[UpdateAdPublisherUseCase#execute] User not logged in`
        })
      )
    }

    const userId = userEntity.getId()

    const requestDraftVO = this.#fromDraftParamToRequestDraftValueObjectMapper
      .setFields(fields)
      .setDraftId(adId)
      .setImages(images)
      .setUserId(userId)
      .map()

    const [updateAdError, updateAdResponse] = await this.#httpRepository.updateAd({
      categoryId,
      requestDraftVO,
      userEntity
    })

    if (updateAdError) return Promise.reject(updateAdError)

    return updateAdResponse.toJSON()
  }
}

export const factory = UpdateAdPublisherUseCase.create
